<acc-modal #letterTpl type="input" action="process" [config]="config"
  [title]="'letter.action.title'|translate"
  (accConfirmed)="orderLetter()"
  (accClosed)="close()" (accCanceled)="close()">
  <!-- Recipient START -->
  @if (recipientLetterAddress) {
    <acc-card>
      <acc-card-body>
        <div [innerHTML]="recipientLetterAddress"></div>
      </acc-card-body>
    </acc-card>
  }
  <!-- Recipient END -->
  <!-- Price START -->
  @if (!hasError()) {
    <div class="fs-4 fw-bold">
      {{ 'letter.action.price'|translate:{amount: (getPrice())} }}
    </div>
  }
  @if (hasError()) {
    <div class="text-bg-danger p-3">
      {{ errorMsgKey!|translate }}
    </div>
  }
  <!-- Price END -->
  <!-- Settings START -->
  <div>
    <div class="mt-2">
      {{ 'letter.action.printSpectrum.title'|translate }}
    </div>
    <div class="d-flex gap-2">
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isPrintSpectrumColor() ? 'primary' : 'outline-primary'"
        (accClick)="setPrintSpectrum('COLOR')">
        <acc-icon name="letter-calc-color"/>
        {{ 'letter.action.printSpectrum.color'|translate }}
      </acc-button>
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isPrintSpectrumColor() ? 'outline-primary' : 'primary'"
        (accClick)="setPrintSpectrum('GRAYSCALE')">
        <acc-icon name="letter-calc-greyscale"/>
        {{ 'letter.action.printSpectrum.grayscale'|translate }}
      </acc-button>
    </div>
    <div class="mt-2">
      {{ 'letter.action.printMode.title'|translate }}
    </div>
    <div class="d-flex gap-2">
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isPrintModeSimplex() ? 'primary' : 'outline-primary'"
        (accClick)="setPrintMode('SIMPLEX')">
        <acc-icon name="letter-calc-simplex"/>
        {{ 'letter.action.printMode.simplex'|translate }}
      </acc-button>
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isPrintModeSimplex() ? 'outline-primary' : 'primary'"
        (accClick)="setPrintMode('DUPLEX')">
        <acc-icon name="letter-calc-duplex"/>
        {{ 'letter.action.printMode.duplex'|translate }}
      </acc-button>
    </div>
    <div class="mt-2">
      {{ 'letter.action.deliveryProduct.title'|translate }}
    </div>
    <div class="d-flex gap-2">
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isDeliveryProductFast() ? 'primary' : 'outline-primary'"
        (accClick)="setDeliveryProduct('FAST')">
        {{ 'letter.action.deliveryProduct.fast'|translate }}&nbsp;
        <acc-icon name="info" [ngbTooltip]="'letter.action.deliveryProduct.fast.info'|translate"/>
      </acc-button>
      <acc-button accClass="w-100" class="w-100" [loadingTimeout]="-1"
        [status]="isDeliveryProductFast() ? 'outline-primary' : 'primary'"
        (accClick)="setDeliveryProduct('CHEAP')">
        {{ 'letter.action.deliveryProduct.cheap'|translate }}&nbsp;
        <acc-icon name="info" [ngbTooltip]="'letter.action.deliveryProduct.cheap.info'|translate"/>
      </acc-button>
    </div>
  </div>
  <div class="mt-2"></div>
  <!-- Settings END -->
</acc-modal>
